import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatToolbarModule } from '@angular/material/toolbar';

export class PromptDialogResult {
  result: boolean;
  value: string;

  constructor() {
    this.result = false;
    this.value = '';
  }
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
  ],
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PromptDialogComponent {
  public title = '';
  public placeholder = '';
  public message = '';

  public dialogResult: PromptDialogResult = new PromptDialogResult();

  @Input() value = '';

  constructor(public dialogRef: MatDialogRef<PromptDialogComponent>) {}

  public closeDialog(): void {
    this.dialogResult.result = true;
    this.dialogResult.value = this.value;
    this.dialogRef.close(this.dialogResult);
  }
}
